import type { TeamsApi } from "@/v2/api/metadata/teams";
import type { ContentTab, DialogTabSaveContext } from "@/v2/framework/dialog/types";
import { createInheritableTabSave } from "@/v2/kits/tenant-inheritance";
import { teamGamesStatusOptions } from "../../../../shared";
import { notifySuccess, teamId } from "../shared";

const prematchTabChildren: ContentTab["children"] = [
  {
    type: "group",
    name: "prematchGame",
    label: "",
    children: [
      {
        type: "select-field",
        name: "status",
        label: "Status",
        required: true,
        placeholder: "Select status",
        options: teamGamesStatusOptions,
        inheritance: { computedKey: "computedStatus", parentKey: "parentStatus" },
      },
    ],
  },
];

export function createPrematchTab(teamsApi: TeamsApi): ContentTab {
  return {
    id: "prematch",
    label: "Prematch",
    save: createInheritableTabSave({
      children: prematchTabChildren,
      persist: async (patch, ctx: DialogTabSaveContext) => {
        await teamsApi.update(teamId(ctx.values), patch);
        notifySuccess();
      },
    }),
    children: prematchTabChildren,
  };
}
